import { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Chip,
  Pagination,
  TextField,
  Stack,
} from "@mui/material";
// import axiosInstance from "../../lib/axios";
import DashboardLayout from "../../components/dashboard/DashboardLayout";

export default function InventoryPage() {
  const [data] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages] = useState(1);
  const [search, setSearch] = useState("");

  // const fetchInventory = async () => {
  //   const res = await axiosInstance.get("/inventory", {
  //     params: { page, search },
  //   });

  //   setData(res.data.items);
  //   setTotalPages(res.data.total_pages);
  // };

  // useEffect(() => {
  //   fetchInventory();
  // }, [page, search]);

  const getStatusChip = (row) => {
    if (row.is_dead_stock)
      return <Chip label="Dead" size="small" color="error" />;
    if (row.is_likely_dead_soon)
      return <Chip label="At Risk" size="small" color="warning" />;
    if (row.is_slow_moving)
      return <Chip label="Slow" size="small" />;
    return <Chip label="Fast" size="small" color="success" />;
  };

  return (
   <DashboardLayout>
     <Box sx={{ p: 3 }}>
      {/* Header */}
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          mb: 2,
        }}
      >
        Inventory
      </Typography>

      {/* Filters */}
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <TextField
          size="small"
          placeholder="Search product / SKU"
          value={search}
          onChange={(e) => {
            setPage(1);
            setSearch(e.target.value);
          }}
        />
      </Stack>

      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: "12px",
          border: "1px solid #E8E6E1",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell>Category</TableCell>
              <TableCell align="right">Stock</TableCell>
              <TableCell align="right">30d Sales</TableCell>
              <TableCell align="right">Stock Cover</TableCell>
              <TableCell align="right">Value</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row) => (
              <TableRow
                key={row.sku_code}
                hover
                sx={{
                  "&:hover": {
                    bgcolor: "#FAFAF8",
                  },
                }}
              >
                <TableCell>{row.product_name}</TableCell>
                <TableCell>{row.sku_code}</TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell align="right">{row.inventory_units}</TableCell>
                <TableCell align="right">{row.units_sold_30d}</TableCell>
                <TableCell align="right">
                  {Math.round(row.stock_cover_days_30d)}d
                </TableCell>
                <TableCell align="right">
                  ₹{row.inventory_cost_value}
                </TableCell>
                <TableCell>{getStatusChip(row)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography sx={{ fontSize: "12px", color: "rgba(0,0,0,0.6)" }}>
          Page {page} of {totalPages}
        </Typography>

        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, val) => setPage(val)}
          size="small"
          shape="rounded"
        />
      </Box>
    </Box>
   </DashboardLayout>
  );
}